Object.defineProperty(exports, "__esModule", { value: true });
exports.CordovaPlatformType = void 0;
var CordovaPlatformType;
(function (CordovaPlatformType) {
    CordovaPlatformType["Ios"] = "ios";
    CordovaPlatformType["Android"] = "android";
    CordovaPlatformType["Browser"] = "browser";
})(CordovaPlatformType = exports.CordovaPlatformType || (exports.CordovaPlatformType = {}));
